var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedpdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.996,
    height: 46,
    viewBox: "0 0 39.996 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf_icon",
    "data-name": "pdf icon",
    transform: "translate(-75.299 -9.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6938",
    "data-name": "Group 6938",
    transform: "translate(75.299 9.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M88.665-500.938a14.736,14.736,0,0,0-4.912,2.947,57.375,57.375,0,0,0-5.413,5.4c-1.7,2.093-2.764,3.869-2.967,5-.067.365-.087,5.05-.067,14.017.019,12.664.039,13.518.2,14.056a6.481,6.481,0,0,0,3.236,3.869c1.445.681.636.643,13.532.643,11.009,0,11.692-.009,12.28-.173a6.452,6.452,0,0,0,4.373-4.34,12.179,12.179,0,0,0,.221-1.853l.058-1.267h-3.092l-.039,1.22a3.29,3.29,0,0,1-.26,1.661,3.452,3.452,0,0,1-1.406,1.421l-.482.259-11.6.029-11.6.019-.539-.24a3.276,3.276,0,0,1-1.531-1.44l-.26-.48-.029-13.5L78.36-487.2l2.813-.048c3.14-.048,3.448-.1,4.652-.72A7.14,7.14,0,0,0,88.4-490.53c.626-1.2.674-1.507.722-4.637l.048-2.8,7.387.019,7.378.029.482.259a3.229,3.229,0,0,1,1.435,1.517l.251.528v16.081h3.092l-.039-8.189c-.029-9.092.009-8.506-.7-9.956a6.893,6.893,0,0,0-2.591-2.612c-1.4-.72-.963-.691-9.294-.711C92.421-501.015,88.906-500.986,88.665-500.938Z",
    transform: "translate(-75.299 501.007)",
    fill: "#be1616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M274.483-10.275a2.766,2.766,0,0,0-1.541.963c-.722.828-.732.867-.732,5.817,0,5.134-.01,5.056.905,5.981.992.982-.308.906,14.456.906s13.465.077,14.457-.906c.915-.925.905-.848.905-5.981s.01-5.056-.905-5.981c-.992-.992.347-.906-14.264-.925C276.814-10.419,274.926-10.4,274.483-10.275Zm7.166,3.2a1.973,1.973,0,0,1,1.3,2.042,2,2,0,0,1-.819,1.763,4.384,4.384,0,0,1-2.668.549H278.23V.358h-1.445V-7.366l2.2.039C281.023-7.3,281.2-7.28,281.649-7.077Zm7.676-.164a4.235,4.235,0,0,1,2,1.021,4.222,4.222,0,0,1,.568.9,3.2,3.2,0,0,1,.25,1.782,3.245,3.245,0,0,1-.27,1.83A3.4,3.4,0,0,1,289.431.214a13.21,13.21,0,0,1-2.745.145h-2.2V-7.347h2.167A23.678,23.678,0,0,1,289.326-7.241Zm10.575.52v.626h-4.816v1.83h4.334v1.252h-4.334V.358h-1.349V-7.347H299.9v.627Z",
    transform: "translate(-262.938 33.403)",
    fill: "#be1616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M400.06,82.229V83.3l1.281-.039c1.464-.039,1.724-.135,1.888-.713a1,1,0,0,0-.472-1.213,3.39,3.39,0,0,0-1.512-.173H400.06Z",
    transform: "translate(-384.768 -53.838)",
    fill: "#be1616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M565.73,83.77v2.6h1.281c1.473,0,2.109-.145,2.61-.588a2.578,2.578,0,0,0,.664-2,2.462,2.462,0,0,0-.6-1.946c-.51-.52-1.107-.664-2.677-.664H565.73Z",
    transform: "translate(-542.637 -53.855)",
    fill: "#be1616"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedpdf);
export default __webpack_public_path__ + "static/media/redpdf.f7c31a2aaa24f8f0912c4a5e3e1919ae.svg";
export { ForwardRef as ReactComponent };